import { csrf } from "./requestHeaders";
const CSRF_MISMATCH_STATUS = 419;
const prepareBody = (method, body) => {
    if (method === "DELETE") {
        return JSON.stringify({ _method: "DELETE" });
    }
    return body ? JSON.stringify(body) : undefined;
};
const request = (url, method = "GET", headers = undefined, body = undefined) => new Request(url, {
    method,
    credentials: "include",
    redirect: "follow",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...headers,
    },
    body: prepareBody(method, body),
});
// A campaign page can be served from Cloudflare's cache, in which case Laravel never runs and
// never reissues the XSRF-TOKEN cookie. That leaves visitors with no (or a stale) token on their
// first protected request. Retry once with a freshly-fetched cookie before giving up.
export const fetchWithCsrfRetry = async (req) => {
    const retryReq = req.clone();
    const response = await fetch(req);
    if (response.status !== CSRF_MISMATCH_STATUS) {
        return response;
    }
    // If the refresh itself fails (e.g. rate-limited), retrying with the same stale token would
    // just produce a second, more confusing failure - surface the original 419 instead.
    let refreshResponse;
    try {
        refreshResponse = await fetch("/api/v2/xsrf-token", { credentials: "include" });
    }
    catch (_a) {
        return response;
    }
    if (!refreshResponse.ok) {
        return response;
    }
    const headers = new Headers(retryReq.headers);
    headers.set("X-XSRF-TOKEN", csrf()["X-XSRF-TOKEN"]);
    return fetch(new Request(retryReq, { headers }));
};
export default request;
